export enum NewRelicTypes {
  GET_USER_CONTEXT = `@newRelic/GET_USER_CONTEXT`,
  SET_USER_CONTEXT = `@newRelic/SET_USER_CONTEXT`,
}

export interface NewRelicState {
  readonly context: string
}
